import { IconProps } from 'src/utils/icon';

const LocationIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 23"
  >
    <path
      fill={fill}
      d="M7.626 22.536C1.194 13.074 0 12.102 0 8.625 0 3.862 3.806 0 8.5 0S17 3.862 17 8.625c0 3.477-1.194 4.449-7.626 13.911a1.054 1.054 0 01-1.748 0zM8.5 12.219c1.956 0 3.542-1.61 3.542-3.594 0-1.985-1.586-3.594-3.542-3.594-1.956 0-3.542 1.61-3.542 3.594 0 1.985 1.586 3.594 3.542 3.594z"
    />
  </svg>
);

export default LocationIcon;
